import { lazy } from "react";

const UioAccessories = lazy(() => import("./uioAccessories/UioAccessories"));
const UioFeaturedAccessories = lazy(
  () => import("./uioFeaturedAccessories/UioFeaturedAccessories"),
);
const UioConfiguratorSave = lazy(
  () => import("./uioConfiguratorSave/UioConfiguratorSave"),
);
const UioDealershipTiles = lazy(() => import("./uioDealershipTiles/UioDealershipTiles"));
const UioFullServiceLease = lazy(
  () => import("./uioFullServiceLease/UioFullServiceLease"),
);
const UioListCardIconBullets = lazy(
  () => import("./uioListCardIconBullets/UioListCardIconBullets"),
);
const UioSectionAccessories = lazy(
  () => import("./uioSectionAccessories/UioSectionAccessories"),
);
const UioSectionCMEBanner = lazy(
  () => import("./uioSectionCMEBanner/UioSectionCMEBanner"),
);
const UioSectionPreview = lazy(() => import("./uioSectionPreview/UioSectionPreview"));
const UioSummary = lazy(() => import("./uioSummary/UioSummary"));
const UioSwiperGallery = lazy(() => import("./uioSwiperGallery/UioSwiperGallery"));

export {
  UioAccessories,
  UioFeaturedAccessories,
  UioConfiguratorSave,
  UioDealershipTiles,
  UioFullServiceLease,
  UioListCardIconBullets,
  UioSectionAccessories,
  UioSectionCMEBanner,
  UioSectionPreview,
  UioSummary,
  UioSwiperGallery,
};
